import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-607e50ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "mod_pagin" }
const _hoisted_7 = { class: "examine_modal" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "mod_pagin" }

import { computed, reactive, ref } from 'vue';
import CDelModal, { RootModal } from '@/components/CDelModal.vue';
import { Table, Pagination, message, Modal, Tooltip, Popover } from 'ant-design-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import router from '@/router';
import http from '@/api/application';
import { columns, IList, columnSign } from './sign';
import { DownloadOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignWall',
  setup(__props) {

const aTable = Table;
const aPagination = Pagination;
const aModal = Modal;
const aTooltip = Tooltip;
const aPopover = Popover;
// 去 新建活动
const toCreate = () => {
  router.push('/application/createSignWall');
};

// 去 修改
const toEdit = (id: number) => {
  router.push({ path: '/application/editSignWall', query: { id: id } });
};

// 去设置
const toConfig = (id: number) => {
  router.push({ path: '/application/configSign', query: { id: id } });
};

// 选择
const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const isDisabled = computed(() => (selectedRowKeys.value.length === 0 ? true : false));
// 分页
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '24', '36', '48', '60'], // 选项
});
const dataSource = ref<IList[]>([]);

// 获取列表
const getList = () => {
  const data = { page: pageConfig.current, page_num: pageConfig.pageSize };
  http
    .get_activity_list({ params: data })
    .then((res) => {
      const resData = res.data.data.data;
      resData.forEach((element: any) => {
        element.status = Boolean(element.status);
      });
      dataSource.value = resData;
      pageConfig.totalSize = res.data.data.total;
    })
    .catch((err) => {
      console.error(err.data.error);
    });
};
getList();

// 删除
const delModal = reactive<RootModal>({
  visible: false,
  title: '删除',
  loading: false,
});

const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const clickDelList = () => {
  http
    .del_activity_info({ params: { id: selectedRowKeys.value.join(',') } })
    .then((res) => {
      message.success(res.data.message);
      openDelModal();
      getList();
    })
    .catch((err) => message.error(err.data.error));
};

// 复制
const copyModal = reactive<RootModal>({
  visible: false,
  title: '复制',
  loading: false,
});
const openCopyModal = (activity_code: string) => {
  copyModal.visible = !copyModal.visible;
  activityCode.value = activity_code;
};
const copyActived = () => {
  http
    .copy_activity_info({ activity_code: activityCode.value })
    .then((res) => {
      message.success(res.data.message);
      copyModal.visible = false;
      getList();
    })
    .catch((err) => message.error(err.data.error));
};

// 查看报告
const examineModal = ref(false);
const activityCode = ref();
const pageConfigSign = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '24', '36', '48', '60'], // 选项
});
const openExamineModal = (activity_code: string) => {
  examineModal.value = !examineModal.value;
  activityCode.value = activity_code;
  getSignList();
};
const signList = ref();
const getSignList = () => {
  http
    .get_front_user_sign_list({
      params: { page: pageConfigSign.current, page_num: pageConfigSign.pageSize, activity_code: activityCode.value },
    })
    .then((res) => {
      signList.value = res.data.data.data;
      pageConfigSign.totalSize = res.data.data.total;
    })
    .catch((err) => console.error(err.data.error));
};

// 设置活动开关
const setActivityStatus = (item: IList) => {
  http
    .set_activity_status({ id: item.id, status: item.status ? 1 : 0 })
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => message.error(err.data.error));
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: toCreate
      }, {
        default: _withCtx(() => [
          _createTextVNode("新建活动")
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        class: "mod_btn",
        type: "link",
        danger: "",
        disabled: _unref(isDisabled),
        onClick: openDelModal
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_svg_icon, {
            class: "mod_btn_icon",
            "icon-class": "del"
          })
        ]),
        default: _withCtx(() => [
          _createTextVNode("删除 ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(aTable), {
        class: "ant-table-striped",
        columns: _unref(columns),
        "data-source": dataSource.value,
        "row-selection": { selectedRowKeys: selectedRowKeys.value, onChange: onSelectChange },
        pagination: false,
        "row-key": "id"
      }, {
        code: _withCtx(({ record }) => [
          _createVNode(_unref(aPopover), { placement: "right" }, {
            content: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                href: record.qr_code,
                target: "blank"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_unref(DownloadOutlined), { class: "" })
                ]),
                _: 2
              }, 1032, ["href"])
            ]),
            default: _withCtx(() => [
              (record.qr_code)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: record.qr_code,
                    class: "btn_code"
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ]),
        href: _withCtx(({ record }) => [
          _createElementVNode("a", {
            href: record.activity_link,
            target: "_blank",
            class: "btn_report"
          }, _toDisplayString(record.activity_link), 9, _hoisted_5)
        ]),
        status: _withCtx(({ record }) => [
          _createVNode(_component_a_switch, {
            checked: record.status,
            "onUpdate:checked": ($event: any) => ((record.status) = $event),
            size: "small",
            onChange: ($event: any) => (setActivityStatus(record))
          }, null, 8, ["checked", "onUpdate:checked", "onChange"])
        ]),
        configure: _withCtx(({ record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "btn_report",
            onClick: ($event: any) => (toConfig(record.id))
          }, {
            default: _withCtx(() => [
              _createTextVNode("去设置")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        operation: _withCtx(({ record }) => [
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 编辑 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (toEdit(record.id))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "sign_wall_edit" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode(" 复制 ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (openCopyModal(record.activity_code))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "sign_wall_look" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        census: _withCtx(({ record }) => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "btn_report",
            onClick: ($event: any) => (openExamineModal(record.activity_code))
          }, {
            default: _withCtx(() => [
              _createTextVNode("查看报告")
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "row-selection"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(aPagination), {
        "show-quick-jumper": "",
        total: pageConfig.totalSize,
        current: pageConfig.current,
        "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.current) = $event)),
        "page-size": pageConfig.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageConfig.pageSize) = $event)),
        pageSizeOptions: pageConfig.options,
        "show-less-items": "",
        "show-size-changer": "",
        onChange: getList,
        onShowSizeChange: getList
      }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
    ]),
    _createVNode(CDelModal, {
      visible: delModal.visible,
      centered: "",
      ok: clickDelList,
      close: openDelModal
    }, null, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: examineModal.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((examineModal).value = $event)),
      centered: "",
      title: "签到列表",
      width: "800px",
      onOk: _cache[5] || (_cache[5] = ($event: any) => (examineModal.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(aTable), {
            class: "ant-table-striped",
            columns: _unref(columnSign),
            "data-source": signList.value,
            pagination: false,
            "row-key": "id"
          }, {
            avatar_url: _withCtx(({ record }) => [
              (record.avatar_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: record.avatar_url,
                    class: "btn_code"
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "data-source"]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(aPagination), {
              "show-quick-jumper": "",
              total: pageConfigSign.totalSize,
              current: pageConfigSign.current,
              "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageConfigSign.current) = $event)),
              "page-size": pageConfigSign.pageSize,
              "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageConfigSign.pageSize) = $event)),
              pageSizeOptions: pageConfigSign.options,
              "show-less-items": "",
              "show-size-changer": "",
              onChange: getSignList,
              onShowSizeChange: getSignList
            }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(CDelModal, {
      visible: copyModal.visible,
      centered: "",
      ok: copyActived,
      close: openCopyModal
    }, {
      title: _withCtx(() => [
        _createTextVNode("是否确认复制此活动？")
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})